import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'rsuite';
import { getOr } from 'lodash/fp';
import LabelByStatus from '../../../../../constants/reservation/StatusLabels';

const StatusCell = ({ dataKey, rowData, ...props }) => (
  <Table.Cell {...props}>
    {getOr('N/A', rowData[dataKey], LabelByStatus)}
  </Table.Cell>
);

StatusCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({ isVisible: PropTypes.bool })
};

StatusCell.defaultProps = {
  rowData: null
};

export default StatusCell;
